import { ActionTypes as LoginActionTypes } from 'store/login/loginConstants';
import { ActionTypes as SignActionTypes } from 'store/sign/signConstants';
import { translate } from 'utils/translateUtil';

const initialState = {
    loginData: {
        accessToken: '',
        clientId: ''
    },
    authToken: '',
    error: {
        hasError: false,
        message: ''
    },
    firstLoginData: {},
    alias: '',
    oldValue: '',
    pending: false,
    firstLoginRedirect: false,
    bksToken: '',
    transactionId: '',
    pwdReset: {
        pending: false,
        hasError: false,
        success: false
    }
};

export default function loginReducer(state = initialState, action: any) {
    const newState = { ...state };
    let response;
    const headers = action.payload ? action.payload.headers : null;

    switch (action.type) {
        case LoginActionTypes.UNMOUNT_LOGIN:
            return {
                ...initialState
            };

        // user sucessfully signed the login
        case SignActionTypes.CHECK_SIGN_FULFILLED:
            if (headers) {
                window.location.href = headers.location;
            }
            response = action.payload.data;
            newState.error = {
                hasError: false,
                message: ''
            };
            newState.pending = false;
            newState.bksToken = response.token;
            return newState;

        case LoginActionTypes.LOGIN_PENDING:
            return {
                ...state,
                pending: true
            };
        case LoginActionTypes.LOGIN_REJECTED:
            if (action.payload.response.status === 409) {
                const signMethod =
                    action.payload.response.data.choosenDigitalSignatureMethod
                        .methodId;
                const enrollmentId =
                    action.payload.response.data.choosenDigitalSignatureMethod
                        .enrollmentId;
                const challengeData = btoa(
                    JSON.stringify(action.payload.response.data.challengeData)
                );
                return {
                    ...state,
                    pending: false,
                    firstLoginRedirect: true,
                    error: {
                        hasError: false
                    },
                    firstLoginData: {
                        signMethod,
                        enrollmentId,
                        challengeData,
                        alias: action.payload.alias,
                        oldPassword: btoa(action.payload.password)
                    }
                };
            } else {
                return {
                    ...state,
                    pending: false,
                    error: {
                        hasError: true,
                        message: translate('loginApp.login-form.error')
                    }
                };
            }

        case LoginActionTypes.LOGIN_FULFILLED:
            if (headers) {
                window.location.href = headers.location;
            }

            return {
                ...newState,
                error: {
                    hasError: false
                }
            };

        case LoginActionTypes.RESET_PASSWORD:
            return {
                ...initialState
            };
        case LoginActionTypes.RESET_PASSWORD_PENDING:
            return {
                ...initialState,
                pwdReset: {
                    ...initialState.pwdReset,
                    pending: true
                }
            };
        case LoginActionTypes.RESET_PASSWORD_REJECTED:
            return {
                ...initialState,
                pwdReset: {
                    ...initialState.pwdReset,
                    pending: false,
                    hasError: true,
                    success: false
                }
            };
        case LoginActionTypes.RESET_PASSWORD_FULFILLED:
            return {
                ...initialState,
                pwdReset: {
                    ...initialState.pwdReset,
                    pending: false,
                    hasError: false,
                    success: true
                }
            };
        default:
            return state;
    }
}
